import React from "react";
import MultiModalPickerWithChooseButton from "../MultiModalPickerWithChooseButton";
import { MultiModalPickerProps } from "../props";
import MultiProductionList from "./MultiProductionList";
import { LabelList } from "../LabelList";

export const ProductionMultiModalPicker = (props: MultiModalPickerProps<server.dto.TourSmall>) => {

  return <>
    <MultiModalPickerWithChooseButton<server.dto.TourSmall>
      onNewClicked={() => { }}
      renderLabelContent={(production) => <div>{production.name}</div>}
      getId={(production) => production.productionId}
      buttonLabel={RESX.Buttons.btnSelect}
      modalTitle={site.currentEnvironment.production.plural}
      modalSize="small"
      renderModalContent={(editedValue, setEditedValue) => <MultiProductionList
        excludeKeys={editedValue.map(production => production.productionId)}
        onChange={setEditedValue}
        value={editedValue}
      />}

      {...props}
    />
  </>;
};


export const SelectedProductions = (props: { value: server.dto.TourSmall[] }) => {
  return <LabelList
    value={props.value}
    renderLabelContent={(production) => <div>{production.name}</div>}
    getId={(production) => production.productionId}
  />;
}